import axios from "axios";
axios.defaults.baseURL = 'https://admin.lotusslots.lol'
// axios.defaults.baseURL = '/api'
// axios.defaults.withCredentials=true;
// axios.defaults.params = {
//     lang:JSON.parse(localStorage.getItem('language')).value
// }
// axios.defaults.data = {
//     lang:JSON.parse(localStorage.getItem('language')).value
// }

const languageItem = localStorage.getItem('language');
const languageData = languageItem ? JSON.parse(languageItem) : null;

if (languageData && languageData.value) {
    axios.defaults.params = {
        lang: languageData.value
    };
    axios.defaults.data = {
        lang: languageData.value
    };
} else {
    console.error('Language data is missing or invalid');
    // Handle the error, maybe set default values or notify the user
}

//请求拦截
axios.interceptors.request.use(config => {
    if (sessionStorage.getItem('token')) {
        let { access_token } = JSON.parse(sessionStorage.getItem('token'))
        config.headers.authorization ='Bearer ' + access_token
    }
    return config
}), function (err) {
    return Promise.reject(err)
}

//响应拦截
axios.interceptors.response.use(response => {
    return response.data
}), (error) => {
    return Promise.reject(error);
}
export default axios



// WEBPACK FOOTER //
// ./src/utils/axios/index.js